// @ts-nocheck
import type { Question } from '../types';

export const nightVisibilityQuestions: Question[] = [
  {
    id: 'q-nv-1',
    topic: 'General',
    question: 'When must you use dipped headlights at night?',
    options: [
      { id: 'q-nv-1o1', text: 'Only on unlit roads' },
      { id: 'q-nv-1o2', text: 'On all roads at night; use main beam only when you cannot dazzle others' },
      { id: 'q-nv-1o3', text: 'Only on motorways' }
    ],
    answerId: 'q-nv-1o2',
    explanation: 'Use dipped headlights at night on all roads. Use main beam only when you cannot dazzle oncoming traffic or vehicles ahead.',
    subject: 'Night & Visibility',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-dipped-lights.jpg'
  },
  {
    id: 'q-nv-2',
    topic: 'General',
    question: 'When should you dip your headlights?',
    options: [
      { id: 'q-nv-2o1', text: 'Only when police ask' },
      { id: 'q-nv-2o2', text: 'When meeting oncoming traffic or following another vehicle closely' },
      { id: 'q-nv-2o3', text: 'Never; main beam is safer' }
    ],
    answerId: 'q-nv-2o2',
    explanation: 'Dip your headlights when you would dazzle oncoming drivers or when following another vehicle so you do not dazzle them in the mirror.',
    subject: 'Night & Visibility',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-oncoming-fullbeam.jpg'
  },
  {
    id: 'q-nv-3',
    topic: 'General',
    question: 'What should you do if you are dazzled by oncoming headlights?',
    options: [
      { id: 'q-nv-3o1', text: 'Look at the headlights to see the car' },
      { id: 'q-nv-3o2', text: 'Slow down or stop if necessary; look toward the left edge of the road' },
      { id: 'q-nv-3o3', text: 'Flash your main beam in response' }
    ],
    answerId: 'q-nv-3o2',
    explanation: 'If dazzled, slow down or stop if needed. Look toward the left edge of the road until the other vehicle has passed.',
    subject: 'Night & Visibility',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-glare.jpg'
  },
  {
    id: 'q-nv-4',
    topic: 'General',
    question: 'When may you use front fog lights?',
    options: [
      { id: 'q-nv-4o1', text: 'Whenever it is dark' },
      { id: 'q-nv-4o2', text: 'In fog or when visibility is seriously reduced' },
      { id: 'q-nv-4o3', text: 'On motorways only' }
    ],
    answerId: 'q-nv-4o2',
    explanation: 'Use front fog lights only when visibility is seriously reduced (e.g. fog, heavy rain). Switch them off when visibility improves.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-5',
    topic: 'General',
    question: 'Why is it harder to judge speed and distance at night?',
    options: [
      { id: 'q-nv-5o1', text: 'It is not; it is the same' },
      { id: 'q-nv-5o2', text: 'You have less visual information; headlights only show a limited area' },
      { id: 'q-nv-5o3', text: 'Other drivers drive faster' }
    ],
    answerId: 'q-nv-5o2',
    explanation: 'At night you see less of the road and other vehicles. It is harder to judge their speed and distance, so drive with extra care.',
    subject: 'Night & Visibility',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-limited-visibility.jpg'
  },
  {
    id: 'q-nv-6',
    topic: 'General',
    question: 'When driving at night in built-up areas with street lighting, what lights should you use?',
    options: [
      { id: 'q-nv-6o1', text: 'No lights; street lights are enough' },
      { id: 'q-nv-6o2', text: 'Dipped headlights so you can see and be seen' },
      { id: 'q-nv-6o3', text: 'Main beam for better visibility' }
    ],
    answerId: 'q-nv-6o2',
    explanation: 'Use dipped headlights at night even in lit areas so you can see the road and other road users can see you.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-7',
    topic: 'General',
    question: 'What should you do if the sun is low and causing glare?',
    options: [
      { id: 'q-nv-7o1', text: 'Speed up to get out of the glare' },
      { id: 'q-nv-7o2', text: 'Slow down, use sun visor, and keep a safe distance; be prepared for others who cannot see well' },
      { id: 'q-nv-7o3', text: 'Use main beam to compensate' }
    ],
    answerId: 'q-nv-7o2',
    explanation: 'Glare reduces visibility. Slow down, use the sun visor, and keep a safe distance. Others may also be affected.',
    subject: 'Night & Visibility',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-sun-glare.jpg'
  },
  {
    id: 'q-nv-8',
    topic: 'General',
    question: 'When may you use rear fog lights?',
    options: [
      { id: 'q-nv-8o1', text: 'Whenever it is raining' },
      { id: 'q-nv-8o2', text: 'When visibility is seriously reduced (e.g. fog); switch off when it improves' },
      { id: 'q-nv-8o3', text: 'At night on motorways only' }
    ],
    answerId: 'q-nv-8o2',
    explanation: 'Use rear fog lights only when visibility is seriously reduced. They can dazzle following drivers; switch them off when visibility improves.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-9',
    topic: 'General',
    question: 'Why should you clean your windscreen and lights regularly?',
    options: [
      { id: 'q-nv-9o1', text: 'To improve fuel economy' },
      { id: 'q-nv-9o2', text: 'Dirt and grime reduce visibility and make lights less effective' },
      { id: 'q-nv-9o3', text: 'It is only required in winter' }
    ],
    answerId: 'q-nv-9o2',
    explanation: 'A dirty windscreen scatters light and reduces visibility. Dirty lights reduce your ability to see and be seen.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-10',
    topic: 'General',
    question: 'You are driving at night and your headlights suddenly fail. What should you do?',
    options: [
      { id: 'q-nv-10o1', text: 'Continue at the same speed' },
      { id: 'q-nv-10o2', text: 'Slow down, pull off the road when safe, and use hazard lights and sidelights if available' },
      { id: 'q-nv-10o3', text: 'Use the horn and continue' }
    ],
    answerId: 'q-nv-10o2',
    explanation: 'If headlights fail, reduce speed, pull off the road when safe, and use hazard lights and sidelights. Get the fault fixed before driving again.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-11',
    topic: 'General',
    question: 'What is "night blindness" in driving terms?',
    options: [
      { id: 'q-nv-11o1', text: 'Being afraid of the dark' },
      { id: 'q-nv-11o2', text: 'Eyes taking time to adjust when moving from lit to unlit areas (or vice versa)' },
      { id: 'q-nv-11o3', text: 'Driving without lights' }
    ],
    answerId: 'q-nv-11o2',
    explanation: 'When you move from bright to dark (or dark to bright), your eyes need time to adapt. Slow down until your vision has adjusted.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-12',
    topic: 'General',
    question: 'When may you use your hazard warning lights while moving?',
    options: [
      { id: 'q-nv-12o1', text: 'Whenever it is dark' },
      { id: 'q-nv-12o2', text: 'To warn of a temporary obstruction (e.g. on a motorway) when allowed by law' },
      { id: 'q-nv-12o3', text: 'In rain or fog' }
    ],
    answerId: 'q-nv-12o2',
    explanation: 'Hazard lights may be used while moving only in specific situations (e.g. to warn of a hazard on a motorway). Rules vary; use when legally allowed.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-13',
    topic: 'General',
    question: 'Why should you reduce speed when driving at night on an unlit road?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-limited-visibility.jpg',
    options: [
      { id: 'q-nv-13o1', text: 'To save fuel' },
      { id: 'q-nv-13o2', text: 'You can only see as far as your headlights; you must be able to stop within that distance' },
      { id: 'q-nv-13o3', text: 'Wildlife only come out at night' }
    ],
    answerId: 'q-nv-13o2',
    explanation: 'On an unlit road you can only see as far as your headlights. You must be able to stop within the distance you can see to be clear.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-14',
    topic: 'General',
    question: 'What should you do if you see a pedestrian wearing dark clothing at night?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-dark-pedestrian.jpg',
    options: [
      { id: 'q-nv-14o1', text: 'Assume they will stay on the pavement' },
      { id: 'q-nv-14o2', text: 'Slow down and be prepared to stop; they are hard to see' },
      { id: 'q-nv-14o3', text: 'Flash your lights to warn them' }
    ],
    answerId: 'q-nv-14o2',
    explanation: 'Pedestrians in dark clothing are difficult to see at night. Slow down and be ready to stop; they may step into the road.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-15',
    topic: 'General',
    question: 'When driving in fog, what should you do?',
    options: [
      { id: 'q-nv-15o1', text: 'Use main beam for better visibility' },
      { id: 'q-nv-15o2', text: 'Use dipped headlights and fog lights if needed; slow down and keep a safe distance' },
      { id: 'q-nv-15o3', text: 'Drive close to the vehicle in front to follow their lights' }
    ],
    answerId: 'q-nv-15o2',
    explanation: 'In fog use dipped headlights and fog lights if visibility is poor. Slow down and keep a safe distance. Main beam reflects off fog and reduces visibility.',
    subject: 'Night & Visibility',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-fog-driving.jpg'
  },
  {
    id: 'q-nv-16',
    topic: 'General',
    question: 'Why should you avoid looking directly at oncoming headlights?',
    options: [
      { id: 'q-nv-16o1', text: 'It is rude' },
      { id: 'q-nv-16o2', text: 'It causes temporary blindness and you may lose your sense of direction' },
      { id: 'q-nv-16o3', text: 'It damages the eyes permanently' }
    ],
    answerId: 'q-nv-16o2',
    explanation: 'Looking at oncoming headlights causes glare and temporary blindness. Look toward the left edge of the road until the vehicle has passed.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-17',
    topic: 'General',
    question: 'When may you drive with only sidelights (parking lights) at night?',
    options: [
      { id: 'q-nv-17o1', text: 'On well-lit urban roads' },
      { id: 'q-nv-17o2', text: 'Sidelights alone are not sufficient for driving at night; use dipped headlights' },
      { id: 'q-nv-17o3', text: 'On motorways' }
    ],
    answerId: 'q-nv-17o2',
    explanation: 'Sidelights are for parking. When driving at night you must use dipped headlights (or main beam where appropriate) so you can see and be seen.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-18',
    topic: 'General',
    question: 'What should you do when approaching a tunnel in daylight?',
    options: [
      { id: 'q-nv-18o1', text: 'Switch off all lights' },
      { id: 'q-nv-18o2', text: 'Switch on dipped headlights before entering; visibility drops inside' },
      { id: 'q-nv-18o3', text: 'Speed up to pass through quickly' }
    ],
    answerId: 'q-nv-18o2',
    explanation: 'Turn on dipped headlights before entering a tunnel so you can see and be seen as visibility drops.',
    subject: 'Night & Visibility',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-tunnel-approach.jpg'
  },
  {
    id: 'q-nv-19',
    topic: 'General',
    question: 'Why is wet road surface more dangerous at night?',
    options: [
      { id: 'q-nv-19o1', text: 'Water cools the engine' },
      { id: 'q-nv-19o2', text: 'Reflections from street lights and headlights make it harder to see; grip is also reduced' },
      { id: 'q-nv-19o3', text: 'It is not more dangerous' }
    ],
    answerId: 'q-nv-19o2',
    explanation: 'Wet roads reduce grip. At night, reflections from lights can make it harder to see the road and other vehicles.',
    subject: 'Night & Visibility'
  },
  {
    id: 'q-nv-20',
    topic: 'General',
    question: 'You are driving at dusk. When should you turn on your headlights?',
    options: [
      { id: 'q-nv-20o1', text: 'Only when it is completely dark' },
      { id: 'q-nv-20o2', text: 'When visibility is reduced so that you or others need lights to see and be seen' },
      { id: 'q-nv-20o3', text: 'Lights are not needed at dusk' }
    ],
    answerId: 'q-nv-20o2',
    explanation: 'Turn on headlights when visibility is reduced (e.g. at dusk or in rain) so you can see and be seen by others.',
    subject: 'Night & Visibility'
  },
];
